<template>
  <div>
    <v-app-bar app color="white">
      <div class="d-flex flex-row align-center">
        <v-img alt="On The Clock Now" class="shrink" contain src="@/assets/fullLogo.png" width="160" />
      </div>

      <v-spacer></v-spacer>
      <v-menu v-if="User" v-model="menu" :close-on-content-click="false" :nudge-width="200" bottom left offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-avatar color="primary" size="30" v-bind="attrs" v-on="on">
            <img :src="getImage" class="image" alt="EmployeeImage" />
          </v-avatar>
        </template>

        <v-card>
          <v-list>
            <v-list-item>
              <v-list-item-avatar>
                <img :src="getImage" class="image" alt="EmployeeImage" />
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>{{ User.name }}</v-list-item-title>
                <v-list-item-subtitle>Admin</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn color="primary" icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>

          <v-list>
            <v-list-item to="/login/location">
              <v-list-item-action>
                <v-icon>mdi-shield-key</v-icon>
              </v-list-item-action>
              <v-list-item-title>Switch Location</v-list-item-title>
            </v-list-item>
            <v-list-item @click="timeClockStatus">
              <v-list-item-action>
                <v-icon>mdi-clock</v-icon>
              </v-list-item-action>
              <v-list-item-title>Status Home</v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item @click="deleteAccount">
              <v-list-item-action>
                <v-icon color="red">mdi-delete</v-icon>
              </v-list-item-action>
              <v-list-item-title class="red--text">Cancel Account</v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
            <!-- <v-list-item>
            <v-list-item-action>
              <v-switch v-model="hints" color="purple"></v-switch>
            </v-list-item-action>
            <v-list-item-title>Enable hints</v-list-item-title>
          </v-list-item> -->
          </v-list>

          <v-card-actions>
            <v-spacer></v-spacer>

            <!-- <v-btn text @click="menu = false"> Cancel </v-btn> -->
            <v-btn color="primary" text @click="logout"> Logout </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-app-bar>
    <v-container>
      <div v-if="Organization">
        <div class="text-h5">{{ Organization.name }}</div>
        <div class="text-caption">{{ Organization.email }}</div>
      </div>
      <div v-else>
        <v-skeleton-loader width="250" type="heading"></v-skeleton-loader>
        <v-skeleton-loader class="mt-2" width="250" type="text"></v-skeleton-loader>
      </div>

      <v-row align="center">
        <v-col>
          <div class="title mt-3">Locations</div>
        </v-col>
        <v-spacer></v-spacer>
        <v-col class="text-right shrink">
          <v-btn small rounded @click="addLocation" color="primary">New</v-btn>
        </v-col>
      </v-row>

      <v-card outlined class="mt-2" v-if="Organization">
        <v-list>
          <v-list-item two-line @click="openLocation(location)" v-for="(location, index) in Organization.Locations"
            :key="index">
            <v-list-item-content>
              <v-list-item-title class="text-capitalize">{{
                location.name
              }}</v-list-item-title>
              <v-list-item-subtitle>{{
                location.Address.addressLine1
              }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action-text>
              {{ location.code }}
            </v-list-item-action-text>
          </v-list-item>
        </v-list>
      </v-card>
      <v-card outlined class="mt-2" v-else>
        <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import organizationService from "@/modules/BackOffice/service.js";
import userService from "@/modules/SignUp/service.js";
import UserImg from "@/assets/images/user.jpeg";

export default {
  name: "backoffice-home",
  data() {
    return {
      menu: false,
      Organization: null,
      User: null,
    };
  },
  created() {
    this.getCurrent();
    this.getCurrentUser()
  },
  computed: {
    getImage() {
      if (this.User && this.User.imageURL) {
        return this.User.imageURL;
      } else return UserImg;
    },
  },
  methods: {
    deleteAccount() {
      return this.$swal
        .fire({
          title: "Are you sure?",
          text: "Deleting your account will result in the permanent deletion of all clock-in entries and location data. This action cannot be undone.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.loading = true;
            // console.log('User', this.User)
            userService
              .removeUser(this.User.id)
              .then((result) => {
                console.log('result', result)
                this.$toast.success("Your account is canceled!", { timeout: 2000 });
                this.$router.push({ name: "authentication-logout" });
              });
            // let newMetadata = obj.metadata;
            // delete newMetadata.signature;

            // return payService
            //   .update(obj.id, { pickedUpAt: null, metadata: newMetadata })
            //   .then((response) => {
            //     console.log("response", response);
            //     this.$toast.success("Payment Marked Un-pickup", {
            //       timeout: 2000,
            //     });
            //     // this.createPayDialog = false;
            //     this.getPay();
            //     // this.saveBtnLoading = false;
            //     // this.snackbar.status = true
            //     // this.snackbar.tet = 'Payment Receive Saved'
            // })
            // .catch(() => {
            //   this.loading = false;
            // });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    timeClockStatus() {
      this.$router.push({ name: 'home' })
    },
    addLocation() {
      console.log('add location')
      this.$router.push({ name: 'location-create', params: { Organization: this.Organization } })
    },
    openLocation(locaiton) {
      console.log("locaiton", locaiton);
      this.$router.push({ path: `/backoffice/${locaiton.id}/location` });
    },

    getCurrent() {
      organizationService
        .getCurrent({ includeLocation: true })
        .then((response) => {
          this.Organization = response.data;
        });
    },
    logout() {
      console.log("logout pressed");
      this.$router.push({ name: "backOfficeLogout" });
    },
    getCurrentUser() {
      organizationService.getCurrentUser().then((response) => {
        this.User = response.data;
      });
    },
  },
};
</script>

<style scoped></style>